
// export default class SelectWeek{

//     static findCurrentWeek(selectRoute,lang){
//         switch(lang){
//             case 'sr':
//                 return this.srCurrentWeek(selectRoute);
//             case 'en':
//                 return this.enCurrentWeek(selectRoute);

//         }

//     }
//     static srCurrentWeek(selectRoute){
//         let findyears = selectRoute.split('-').join(' ');
//         var week = findyears.split(' do ')[0].split(' ').filter(x=> x != '').pop();
//         return week;
//     }
//     static enCurrentWeek(selectRoute){
//         let findyears = selectRoute.split('-').join(' ');
//         var week = findyears.split(' to ')[0].split(' ').filter(x=> x != '').pop();
//         return week;
//     }
  
// }

export default class SelectWeek {
  /**
   * Ulaz: npr.
   *  - "cene-jabuka-od-01.12.2025-do-08.12.2025-voce-voce-2025"
   *  - "apple-prices-from-01.12.2025-to-08.12.2025-fruit-fruit-2025"
   *
   * Izlaz:
   *  - "01.12.2025"
   */
  static findCurrentWeek(selectRoute) {
    if (!selectRoute) return ''

    // zameni '-' sa razmakom radi lakšeg parsiranja
    const normalized = String(selectRoute).split('-').join(' ')

    // detektuj separator na osnovu jezika u URL-u
    let separator = null
    if (normalized.includes(' do ')) {
      separator = ' do '
    } else if (normalized.includes(' to ')) {
      separator = ' to '
    } else {
      // ne prepoznaje format
      return ''
    }

    // deo pre "do"/"to"
    const before = normalized.split(separator)[0]

    // uzmi poslednju "reč" (trebalo bi da je "01.12.2025")
    const parts = before.split(' ').filter(Boolean)

    return parts.length ? parts[parts.length - 1] : ''
  }
}

